import type { ActiveColumnFilter } from './useActiveColumnFilters';
import './ActiveFilterChips.css';

interface ActiveFilterChipsProps {
  filters: ActiveColumnFilter[];
  onRemove: (colId: string) => void;
}

/** One chip per applied column filter, so a filter on an off-screen column is still visible. */
export function ActiveFilterChips({ filters, onRemove }: ActiveFilterChipsProps) {
  if (filters.length === 0) return null;
  return (
    <div className="sky-active-filters" data-testid="active-filter-chips">
      <span className="sky-active-filters-label">Filtered by</span>
      {filters.map((filter) => (
        <span key={filter.colId} className="sky-active-filter-chip" title={`${filter.label}: ${filter.summary}`}>
          <span className="sky-active-filter-chip-text">
            <strong>{filter.label}</strong>
            {filter.summary ? `: ${filter.summary}` : ''}
          </span>
          <button
            type="button"
            className="sky-active-filter-chip-remove"
            aria-label={`Remove ${filter.label} filter`}
            onClick={() => onRemove(filter.colId)}
          >
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </span>
      ))}
    </div>
  );
}
